import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { Formik } from 'formik';
import {
  fetchMarketingPreferences,
  updateMarketingPreferences,
} from '../myprofile/MyProfileActions';

import { MarketingPreferencesConfig } from './MarketingPreferencesConfig';
// eslint-disable-next-line import/no-named-as-default
import { FormCheckboxField } from '../../common/components/formFields';

function MarketingPreferencesPage() {
  const dispatch = useDispatch();
  const [marketingPreferences, setMarketingPreferences] = useState(
    new MarketingPreferencesConfig(false, false, false, false),
  );

  const updateField = (marketingPreferences) => {
    dispatch(updateMarketingPreferences(marketingPreferences))
      .then((config) => setConfig(config))
      .catch(() => {
        dispatch(fetchMarketingPreferences()).then((config) => setConfig(config));
      });
  };

  const setConfig = (config, isUpdate = true) => {
    if (!config) return;
    const {
      phoneMarketingAllowed,
      emailMarketingAllowed,
      smsMarketingAllowed,
      postMarketingAllowed,
    } = config;

    const updatedMerketingPreferences = new MarketingPreferencesConfig(
      phoneMarketingAllowed,
      emailMarketingAllowed,
      smsMarketingAllowed,
      postMarketingAllowed,
    );

    setMarketingPreferences(updatedMerketingPreferences);
    if (isUpdate) {
      updateField(updatedMerketingPreferences);
    }
  };

  useEffect(() => {
    dispatch(fetchMarketingPreferences()).then((config) => setConfig(config, false));
  }, [dispatch]);

  const handleOnSystemNotificationChange = (config) => {
    setConfig(config);
  };

  return (
    <Formik initialValues={{}} onSubmit={() => null}>
      <Row className="mt-4 d-flex flex-row flex-wrap">
        <Col>
          <FormCheckboxField
            name="phone"
            label="Phone"
            onChange={() => {
              handleOnSystemNotificationChange(marketingPreferences.pressPhone());
            }}
            value={marketingPreferences.phoneMarketingAllowed}
          />
        </Col>

        <Col>
          <FormCheckboxField
            name="email"
            label="Email"
            onChange={() => {
              handleOnSystemNotificationChange(marketingPreferences.pressEmail());
            }}
            value={marketingPreferences.emailMarketingAllowed}
          />
        </Col>

        <Col>
          <FormCheckboxField
            name="sms"
            label="SMS"
            onChange={() => {
              handleOnSystemNotificationChange(marketingPreferences.pressSms());
            }}
            value={marketingPreferences.smsMarketingAllowed}
          />
        </Col>

        <Col>
          <FormCheckboxField
            name="post"
            label="Post"
            onChange={() => {
              handleOnSystemNotificationChange(marketingPreferences.pressPost());
            }}
            value={marketingPreferences.postMarketingAllowed}
          />
        </Col>
      </Row>
    </Formik>
  );
}

export default MarketingPreferencesPage;
